import { useModalManager } from "@/modules/hooks";
import { createContext, useContext } from "react";

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const modalManager = useModalManager();

  return (
    <ModalContext.Provider value={modalManager}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModals() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModals must be used within a ModalProvider");
  }
  return context;
}
